import { VideoAltKeys as altKey } from '../../../../../../services/analytics/formatters/alt-meta-keys'
import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { AnalyticsEvent } from '../../../../event'
import { AttributeFormatter } from '../../formatters/attribute'
import { VideoAttrFormatter } from '../../formatters/video'
import { PageEvents } from '../../page-events'

const mParticleEvents: any = new PageEvents()

export class VideoEvents extends AnalyticsEvent {

    public attributeFormatter = new AttributeFormatter()
    public videoAttrFormatter = new VideoAttrFormatter()
    /**
     * Handle video clicked/started event
     */
    public handle(): void {

        let eventName = ''
        const attrs = [
            key.DOMAIN,
            key.TITLE,
            key.GLOBAL_ID,
            key.CATEGORY,
            key.VID_ID_FRM_PLYLST,
            key.VID_NAME,
            key.VID_PLATFORM,
            key.VID_AUTHOR,
            key.VID_ID,
            key.VID_CENTER,
            key.VID_QUALITY,
            key.VID_PUB_DATE,
            key.VENDOR,
            key.VID_NAME_PATH,
            key.VID_PLAYER_NAME,
            key.VID_FEATURED
        ]

        const altAttrs = {
            [key.TITLE] : altKey.TITLE,
            [key.GLOBAL_ID]: altKey.GLOBAL_ID,
            [key.CATEGORY]: altKey.CATEGORY
        }

        switch(this.type) {
            case 'video-full-screen':
                eventName = PageEvents.mpEventName.VideoFullScreen
                break
            case 'video-started':
                eventName = PageEvents.mpEventName.VideoStarted
                break
            case 'video-paused':
                eventName = PageEvents.mpEventName.VideoPaused
                break
            case 'video-ended':
                eventName = PageEvents.mpEventName.VideoEnded
                break
            case 'video-player-error':
                eventName = PageEvents.mpEventName.VideoPlayerError
                attrs.push(key.VID_ERROR_MSG)
                break
        }
        const data = this.attributeFormatter.format(
            attrs, {
            ...this.metaProperties,
            ...this.videoAttrFormatter.format(this.value)
        }, altAttrs)

        mParticleEvents.logEvent(
            eventName,
            PageEvents.mpEventType.Other,
            data,
            {'Google.NonInteraction': true}
        )
    }

}
